import React from 'react';
import { AlertCircle, X } from 'lucide-react';

function ConfirmationModal({ isOpen, onConfirm, onCancel, title, message, confirmText = 'Delete', confirmClass = 'cancel-btn' }) {
  if (!isOpen) return null;
  return (
    <div className="modal" onClick={onCancel}>
      <div className="modal-content" onClick={e => e.stopPropagation()} style={{maxWidth: '450px'}}>
        <div className="modal-header">
          <div className="modal-title-group">
            <AlertCircle size={24} color={confirmClass === 'cancel-btn' ? 'var(--google-red)' : 'var(--google-blue)'} />
            <h3>{title || 'Confirm Action'}</h3>
          </div>
          <button className="close-btn" onClick={onCancel}><X size={20} /></button>
        </div>
        
        <p style={{marginBottom: '2rem', color: 'var(--google-grey-600)', lineHeight: '1.6', fontSize: '0.95rem'}}>
          {message || 'Are you sure you want to proceed?'}
        </p>
        
        <div className="form-actions">
          <button className="secondary-btn" onClick={onCancel}>Cancel</button>
          <button className={confirmClass} onClick={onConfirm}>{confirmText}</button>
        </div>
      </div>
    </div>
  );
}

export default ConfirmationModal;
